import * as actionCreators from '../actionTypes';

const initialState = {
  productList: [],
  allProducts: [],
  listloading: false,
  listerror: null,

  deleteMessage: null,
  isDelete: false,

  submitMessage: null,
  isSubmitted: false,
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    // Product List
    case actionCreators.PRODUCT_LIST_CHECK:
      return {
        ...state,
        listloading: true,
        productList: [],
        isDelete: false,
      };

    case actionCreators.PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        productList: action.payload,
        listloading: false,
        isDelete: false,
      };
    case actionCreators.PRODUCT_LIST_FAIL:
      return {
        ...state,
        listerror: action.payload.request && action.payload.request.statusText,
        listloading: false,
        isDelete: false,
      };

    case actionCreators.ALL_PRODUCTS_CHECK:
      return {
        ...state,
        allProductsLoading: true,
      };

    case actionCreators.ALL_PRODUCTS_SUCCESS:
      return {
        ...state,
        allProductsLoading: false,
        allProducts: action.payload,
      };

    case actionCreators.ALL_PRODUCTS_FAIL:
      return {
        ...state,
        allProductsLoading: false,
      };

    // Product Delete
    case actionCreators.PRODUCT_DELETE_CHECK:
      return {
        ...state,
        productList: [],
        isDelete: false,
      };
    case actionCreators.PRODUCT_DELETE_SUCCESS:
      return {
        ...state,
        isDelete: true,
        deleteMessage: action.payload,
      };
    case actionCreators.PRODUCT_DELETE_FAIL:
      return {
        ...state,
        isDelete: false,
      };

    // Service UPDATE
    case actionCreators.PRODUCT_UPDATE_CHECK:
      return {
        ...state,
        productList: [],
        isSubmitted: false,
      };
    case actionCreators.PRODUCT_UPDATE_SUCCESS:
      return {
        ...state,
        isSubmitted: true,
        submitMessage: action.payload,
      };
    case actionCreators.PRODUCT_UPDATE_FAIL:
      return {
        ...state,
        isSubmitted: false,
      };

    default:
      return { ...state };
  }
};
export default productReducer;
